@if (hasBreadcrumb()) {
  <div class="centered-fullwidth relative">
    <app-breadcrumb />
  </div>
}

@if (pageData() && pageContext()) {
  @for (block of pageData()!.blocks; track block._uuid) {
    @let component = block.type | getComponentByType;
    @let context = pageContext()?.[$index];
    @if (component && context) {
      <ng-container
        [ngComponentOutletInputs]="{
          data: block.data,
          position: context.position,
          isImageInPreviousBlocks: context.isImageInPreviousBlocks,
        }"
        [ngComponentOutlet]="component" />
    }
  }
}
